import React, { useState, useEffect, useRef, useMemo, useCallback  } from "react";

import userImage from "../../assets/img/user.png";
import { Card } from "primereact/card";
import { notification } from "antd";
import { FaRegBell } from "react-icons/fa";
import { FaUserCog } from "react-icons/fa";
import { FaFileSignature } from "react-icons/fa";
import { MdNotificationsActive } from "react-icons/md";
import { Divider } from "../PrimeReact.js";
import { InputTextarea } from "primereact/inputtextarea";
import { Controller, useForm } from "react-hook-form";
import { Calendar } from "primereact/calendar";
import { RadioButton } from "primereact/radiobutton";
import { Dropdown } from "primereact/dropdown";
import GV from "../../services/globalVar";
import { format } from "date-fns";
import dashboardService from "../../services/dashboard-service";
import { Toast } from "../PrimeReact";
import { BlockUI } from "primereact/blockui";
import { ProgressSpinner } from "primereact/progressspinner";
import { IoKeyOutline } from "react-icons/io5";
import { FaSignature } from "react-icons/fa";
import { RiShieldKeyholeLine } from "react-icons/ri";
import { Dialog } from "primereact/dialog";
import SecurityService from "../../services/security-service.js";
import SignatureCanvas from "react-signature-canvas";
import { FaEdit,FiCheck  } from "react-icons/fa";
import Cropper from 'react-easy-crop'


const Profile = () => {
  const ds = new dashboardService();
  const toast = useRef(null);
  const ss = new SecurityService();
  
  const [btnclicktxt, setBtnclicktxt] = useState("");
  const [frequency, setFrequency] = useState("");
  const [isDisabled, setIsDisabled] = useState("k");
  const [selectDate, setSelectDate] = useState([]);
  const [selectDrop, setSelectDrop] = useState([]);
  const [getReminderDats, setGetReminderDats] = useState([]);
  const [update, setUpdate] = useState([]);
  const [isProcess, setIsProcess] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [isPassValidMsg, setIsPassValidMsg] = useState("");
  const [isPassValid, setIsPassValid] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isShowPassStrength, setIsShowPassStrength] = useState(false);
  const [profileDetails, setProfileDetails] = useState({});
  const [documentURL, setDocumentURL] = useState(null);
  const fileInputRef = useRef(null);
  const [image, setImage] = useState(null);
  const [tempImage, setTempImage] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showTick, setShowTick] = useState(false);
  const [crop, setCrop] = useState({ x: 0, y: 0 })
  const [zoom, setZoom] = useState(1)
  const [isCrop, setIsCrop] = useState(false)
  const [croppedImage, setCroppedImage] = useState(null);

 
  const [validationPass, setValidationPass] = useState([
    { id: 1, title: "Atleast 1 upper case letters (A - Z)", isValid: false },
    { id: 2, title: "Atleast 1 lower case letters (a-z)", isValid: false },
    { id: 3, title: "Atleast 1 number (0-9)", isValid: false },
    {
      id: 4,
      title: "Atleast 1 non-alphanumeric symbol (e.g. '@$%^!%*+=?|.&')",
      isValid: false,
    },
    {
      id: 5,
      title: "Minimum 8 characters to Maximum 16 characters",
      isValid: false,
    },
    // { id: 6, title: "No white space", isValid: false },
  ]);
  const toggleShowNewPassword = () => {
    setShowNewPassword((prevState) => !prevState);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const togglePasswordVisibility1 = () => {
    setShowPassword1(!showPassword1);
  };
  const categories = [
    { name: "Once", key: "Once" },
    { name: "Repeat", key: "Repeat" },
  ];
  const [reminderType, setReminderType] = useState(categories[0]);
  const [termName, setTermName] = useState([
    { id: 1, name: "Weekly", label: "Weekly" },
    { id: 2, name: "Monthly", label: "Monthly" },
    { id: 3, name: "Yearly", label: "Yearly" },
  ]);

  const handleSelectTerm = (e) => {
    setSelectDrop(e);
  };
  const defaultValues = {
    startdate: "",
    enddate: "",
    frequency: "",
    selectdate: "",
    remindertitle: "",
    description: "",
  };

  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    trigger,
    setError,
    clearErrors,
    watch,
    formState: { errors },
  } = useForm({ mode: "onChange", defaultValues });

  const defaultValues2 = {
    password: "",
    confirmpass: "",
  };
  
  const signaturePadRef = useRef(null);
  const handleSaveSignature = () => {
    if (signaturePadRef.current) {
      const signatureData = signaturePadRef.current.toDataURL();
      btnClick("");
    }
  };

  const handleClearSignature = () => {
    if (signaturePadRef.current) {
      signaturePadRef.current.clear(); 
    }
    setDocumentURL(null); 
  };

  const getCroppedImg = async (imageSrc, pixelCrop) => {
    const image = new Image();
    image.src = imageSrc;

    const canvas = document.createElement('canvas');
    canvas.width = pixelCrop.width;
    canvas.height = pixelCrop.height;
    const ctx = canvas.getContext('2d');

    ctx.drawImage(
      image,
      pixelCrop.x,
      pixelCrop.y,
      pixelCrop.width,
      pixelCrop.height,
      0,
      0,
      pixelCrop.width,
      pixelCrop.height
    );

    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        resolve(blob);
      }, 'image/jpeg');
    });
  };
  const handleImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      const newImage = URL.createObjectURL(event.target.files[0]);
      setImage(newImage);
      setIsCrop(true); 
    }
  };

  const handleSaveProfile = () => {
    const InputJson = {
      TenantID: GV.userDet.tenantDetail.tenantID,
      AppUserID: GV.userDet.appUser.appuserID,
    };

    const formData = new FormData();
    formData.append("InputJson", JSON.stringify(InputJson));

    if (croppedImage) {
      if (croppedImage instanceof Blob || croppedImage instanceof File) {
        formData.append("docs", croppedImage, "profile-photo.jpg");
      } else {
        console.error("croppedImage is not a valid Blob or File");
        return;
      }
    } else if (image) {
      formData.append("docs", image);
    }

    ds.SaveUserProfilePicture(formData)
      .then((res) => {
        toast.current.show({
          severity: "success",
          summary: res.data.message,
        });
        GetAppUser();
        setIsCrop(false);
      })
      .catch((error) => {
        toast.current.show({
          severity: "error",
          summary: "Error saving profile photo",
        });
      });
  };

 
  const UpdateUserPassword = (data) => {
    let isPass = validationPass.every((x) => x.isValid);
    if (!isPass) return;
    if (isPassValidMsg === "Password missmatch") return;
    setIsProcess(true);
    const datas = {
      AppUserID: GV.userDet.appUser.appuserID,
      TenantID: GV.userDet.tenantDetail.tenantID,
      Password: data.confirmpass,
    };
    ss.UpdateUserPassword(datas).then((res) => {
      setIsProcess(false);
      setBtnclicktxt("");
      setIsShowPassStrength(false);
      toast.current.show({
        severity: "success",
        summary: res.data.errors,
      });
    });
  };

  const GetAppUser = () => {
    setIsProcess(true);
    ds.GetAppUser(
      GV.userDet.tenantDetail.tenantID,
      GV.userDet.appUser.appuserID
    ).then((res) => {
      setProfileDetails(res.data.data);
      if(res.data.data) {
    setIsProcess(true);
        const datas = {
          DocIDs: res.data.data.profileImageID.toString(),
          DocCategory: "ProfilePicture",
        };
        ds.DownloadDocs(datas).then((res) => {
          setImage(res.data.data[0].documentURL);
          setTempImage(res.data.data[0].documentURL);
          setIsProcess(false);
        })
      }
    }).catch((err) =>setIsProcess(false));
  };

  const saveSignature = () => {
    if (signaturePadRef.current) {
      const signatureData = signaturePadRef.current.toDataURL();
      const base64String = signatureData.split(",")[1]; 
  
      const datas = {
        TenantID: GV.userDet.tenantDetail.tenantID,
        AppUserID: GV.userDet.appUser.appuserID,
        IsChanged: true,
        FileName: `${profileDetails?.firstName || ""}${profileDetails?.lastName || ""}${GV.userDet.appUser.appuserID}.jpg`,
        SignBase64: base64String, 
      };
  
      ds.UpdateUserSignature(datas)
        .then((res) => {
          toast.current.show({
            severity: "success",
            summary: res.data.message,
          });
          btnClick("");
          GetAppUser();
        })
        .catch((err) => {
          console.error("Error updating user signature:", err);
        });
    }
  };
  
  const onCropComplete = async (croppedArea, croppedAreaPixels) => {
    if (!image) return;

    const croppedImg = await getCroppedImg(image, croppedAreaPixels);
    setCroppedImage(croppedImg);
  };

  const DownloadDocs = () => {
    setIsProcess(true);
    const datas = {
      DocIDs: profileDetails.userSignatureID.toString(),
      DocCategory: "UserSignature",
    };
  
    ds.DownloadDocs(datas)
      .then((res) => {
        setIsProcess(false);
        console.log(res.data.data, "datas");
  
        if (Array.isArray(res.data.data) && res.data.data.length > 0) {
          setDocumentURL(res.data.data[0].documentURL); 
        }
  
        btnClick("sig"); 
      })
      .catch((err) => {
        setIsProcess(false);
        btnClick("sig"); 
      });
  };
  
  
  const {
    formState: { errors: errors2 },
    register: register2,
    control: control2,
    handleSubmit: handleSubmit2,
    reset: reset2,
    setValue2,
  } = useForm({ mode: "onChange", defaultValues2 });

  const btnClick = (status) => {
    setBtnclicktxt(status);
  };

  const [daysDifference, setDaysDifference] = useState(null);

  const watchStartDate = watch("startdate");
  const watchEndDate = watch("enddate");

  const checkPassStrength = (e) => {
    setIsShowPassStrength(true);

    const password = e.target.value;
    validationPass[0].isValid = /[A-Z]/.test(password);
    validationPass[1].isValid = /[a-z]/.test(password);
    validationPass[2].isValid = /[0-9]/.test(password);
    validationPass[3].isValid = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(
      password
    );
    validationPass[4].isValid = password.length >= 8 && password.length <= 16;
    // validationPass[5].isValid = !/\s/.test(password);
    setIsPassValid(password);
    setValidationPass([...validationPass]);
  };
  const checkBothPass = (e) => {
    let pass = e.target.value;
    if (isPassValid === pass) {
      setIsPassValidMsg("");
    } else {
      setIsPassValidMsg("Password missmatch");
    }
  };
  const validateDates = () => {
    if (reminderType.name === "Repeat") {
      const startDate = new Date(watchStartDate);
      const endDate = new Date(watchEndDate);

      if (startDate && endDate) {
        const differenceInTime = endDate - startDate;
        const differenceInDays = differenceInTime / (1000 * 3600 * 24);

        if (frequency.name === "Weekly" && differenceInDays < 14) {
          setError("enddate", {
            type: "manual",
            message:
              "For weekly frequency, the difference must be at least 14 days.",
          });
          return false;
        }

        if (frequency.name === "Monthly" && differenceInDays < 60) {
          setError("enddate", {
            type: "manual",
            message:
              "For monthly frequency, the difference must be at least 60 days.",
          });
          return false;
        }

        clearErrors("enddate");
        return true;
      }
    }

    return true;
  };

  const onSubmit = (data) => {
    // if (validateDates()) {
    //   return;
    // } else {

    // }
    setIsProcess(true);
    const datas = {
      ReminderID: update.reminderID ? update.reminderID : 0,
      ReminderType: reminderType.key ? reminderType.key : reminderType.name,
      Frequency: frequency?.name ? frequency?.name : null,
      ReminderDate: data.selectdate
        ? format(new Date(data.selectdate), "yyyy-MM-dd")
        : null,
      Title: data.remindertitle,
      DetailDescription: data.description,
      StartDateTime: format(new Date(data.startdate), "yyyy-MM-dd"),
      EndDateTime: format(new Date(data.enddate), "yyyy-MM-dd"),
      Status: "Active",
      UserID: GV.userDet.appUser.appuserID,
      TenantID: GV.userDet.tenantDetail.tenantID,
      CreatedOn: format(new Date(new Date()), "yyyy-MM-dd"),
      CreatedBy: GV.userDet.appUser.appuserID.toString(),
    };
    ds.SaveUserReminder(datas).then((res) => {
      setIsProcess(false);
      GetReminder();
      setReminderType(categories[0]);
      toast.current.show({
        severity: "success",
        summary: res.data.message,
      });
      reset();
      setShowButton(false);
    });
  };

  const GetReminder = () => {
    setIsProcess(true);
    const datas = {
      Status: "Active",
      UserID: GV.userDet.appUser.appuserID,
      TenantID: GV.userDet.tenantDetail.tenantID,
    };
    ds.GetReminder(datas)
      .then((res) => {
        setIsProcess(false);
        setGetReminderDats(res.data.data);
      })
      .catch((err) => setIsProcess(false));
  };

  const bindValues = (data, status) => {
    setUpdate(data);
    setIsDisabled(status);
    setValue("startdate", new Date(data.startDateTime));
    setValue("enddate", new Date(data.endDateTime));
    setValue("remindertitle", data.title);
    setValue("description", data.detailDescription);
    setReminderType({ key: data.reminderType });

    if (data.reminderType === "Repeat") {
      const find = termName.find((a) => a.name === data.frequency);
      setValue("frequency", find);
      setFrequency(find);
      setSelectDate(new Date(data.reminderDate));
      setValue("selectdate", new Date(data.reminderDate));
    }
    setShowButton(true);
  };

  const clearBtn = () => {
    btnClick("");
    setShowButton(false);
    reset();
    setIsDisabled("");
    setReminderType(categories[0]);
  };

  const newBtn = () => {
    reset();
    setIsDisabled("");
    setReminderType(categories[0]);
    setShowButton(false);
  };


  const SaveAppUser = () => {
    setIsProcess(true);
    const datas = {
      "AppUserID" : GV.userDet.appUser.appuserID,
      "Prefix" : profileDetails?.prefix,
      "Suffix" :  profileDetails?.suffix,
      "PrimaryEmail" : profileDetails?.primaryEmail,
      "SecondaryEmail" : document.getElementById("secondaryEmail").value,
      "ContactPhone" : profileDetails?.contactPhone,
      "SecondaryContactPhone" :  document.getElementById("secondaryPhone").value, 
      "FirstName" :profileDetails?.firstName,
      "LastName" : profileDetails?.lastName, 
      "Gender" :  profileDetails?.gender,
      "DOB" : profileDetails?.dob.split()['T'],
      "TenantID" : GV.userDet.tenantDetail.tenantID
    }
  ds.SaveAppUser(datas).then((res) => {
    setIsProcess(false);
    toast.current.show({
      severity: "success",
      summary: res.data.message,
    });
    clearFields();
    GetAppUser();
  }).catch((err) => {setIsProcess(false)
   toast.current.show({
      severity: "success",
      summary: err.data.errors,
    })})
  }

  const SaveUserProfilePicture = async () => {
    if (!selectedFile) return;

    const formData = new FormData();
    formData.append("profileImage", selectedFile);
    formData.append("TenantID", GV.userDet.tenantDetail.tenantID);
    formData.append("AppUserID", GV.userDet.appUser.appuserID);

    const data = {
      profileImage: formData,
      TenantID: GV.userDet.tenantDetail.tenantID,
      AppUserID: GV.userDet.appUser.appuserID
    };

    try {
      const response = await ds.SaveUserProfilePicture(data);  // API call

      if (response && response.status === 200) {
        setShowTick(false); // Hide tick after upload
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  const clearFields = () => {
    document.getElementById("secondaryEmail").value = "";
    document.getElementById("secondaryPhone").value = "";
    btnClick("");
  };

  useEffect(() => {
    GetReminder();
    GetAppUser();
  }, []);

  return (
    <>
      <BlockUI blocked={isProcess}>
        <Toast ref={toast}></Toast>

        <div className="card card-borderless cc-greyCard-custm mb-3 p-2">
          <div className="ms-2 my-2 me-2">
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <h4 className="m-0">Profile</h4>
            </div>
          </div>
        </div>
        <div className="card card-borderless cc-greyCard-custm mb-3 p-3">
          <div className="row gap-3 m-2">
            <div className="col-md-2 col-sm border border-1">
              <div
                className="text-center position-relative border-1"
                style={{ top: "9%" }}
              >
                <img
                  src={image}
                  // src={userImage}
                  alt="Profile"
                  className="rounded-circle mb-2"
                  style={{ width: "121px", height: "121px" }}
                />

                <div
                  className="position-absolute"
                  style={{
                    top: "70%",
                    left: "65%",
                    backgroundColor: "white",
                    borderRadius: "50%",
                    padding: "5px",
                    cursor: "pointer",
                    boxShadow: "0px 2px 5px rgba(0,0,0,0.2)",
                  }}
                  onClick={() => fileInputRef.current.click()} 
                >
                  <FaEdit size={20} color="black" />
                </div>

                <input
                  type="file"
                  ref={fileInputRef}
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={handleImageChange}
                />
              </div>

              <div
                className="rounded p-3"
                style={{
                  height: "60vh",
                  overflow: "auto",
                  borderColor: "#BFBFBF",
                }}
              >
                <div className="text-center align-items-center mb-4">
                  <div className="pt-5">
                    <p className="m-0 fs-6">
                      <strong>
                        {profileDetails?.firstName +
                          " " +
                          profileDetails?.lastName}
                      </strong>
                    </p>
                    <strong className="text-muted ">{GV.userDet.role.roleName?.toUpperCase()}</strong>
                    <hr />
                    <p>
                      <strong>Email </strong>
                      <br />
                      {profileDetails?.primaryEmail}
                    </p>
                    <p>
                      <strong>Contact </strong>
                      <br />
                      {profileDetails?.contactPhone}
                    </p>
                  </div>
                </div>
                
              </div>
            </div>
            <>
              <div className="col-md border border-1 p-3">
                <div className="row">
                  <div className="col-md-12 ">
                    <h5>My Information</h5>
                    <hr className="mt-0" />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-6 ">
                    <div className="col-md-12 col-sm-12 d-flex  mb-2">
                      <div className="col-md col-sm d-flex justify-content-center align-items-center">
                        <i
                          className="pi pi-user-edit"
                          style={{ fontSize: "3rem" }}
                        ></i>
                      </div>
                      <div className="col-md-10 col-sm-10 p-2">
                        <p className="m-0">
                          <p className="m-0 fs-5">Security Info</p>
                          <p className="m-0">
                            Keep your verification methods and security{" "}
                          </p>
                          <button
                            onClick={() => btnClick("pnp")}
                            style={{
                              backgroundColor: "transparent",
                              color: "#70CDF3",
                            }}
                          >
                            {" "}
                            Update Info
                          </button>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 ">
                    <div className="col-md-12 col-sm-12 d-flex  mb-2">
                      <div className="col-md col-sm d-flex justify-content-center align-items-center">
                        <IoKeyOutline style={{ fontSize: "3rem" }} />
                      </div>
                      <div className="col-md-10 col-sm-10 p-2">
                        <p className="m-0">
                          <p className="m-0 fs-5">Password</p>
                          <p className="m-0">
                            Make your password stronger, or change it if someone
                            else knows it.
                          </p>
                          <button
                            onClick={() => {
                              btnClick("pas");
                              reset2();
                              setIsShowPassStrength(false);
                              setIsPassValidMsg("");
                            }}
                            style={{
                              backgroundColor: "transparent",
                              color: "#70CDF3",
                            }}
                          >
                            {" "}
                            Change Password
                          </button>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-6 ">
                    <div className="col-md-12 col-sm-12 d-flex  mb-2">
                      <div className="col-md col-sm d-flex justify-content-center align-items-center">
                        <FaFileSignature style={{ fontSize: "3rem" }} />
                      </div>
                      <div className="col-md-10 col-sm-10 p-2">
                        <p className="m-0">
                          <p className="m-0 fs-5">Your Signature</p>
                          <p className="m-0">Digital form of your signature </p>
                          <button
                            onClick={() => DownloadDocs()}
                            style={{
                              backgroundColor: "transparent",
                              color: "#70CDF3",
                            }}
                          >
                            Update Signature
                          </button>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 ">
                    <div className="col-md-12 col-sm-12 d-flex  mb-2">
                      <div className="col-md col-sm d-flex justify-content-center align-items-center">
                        <i
                          className="pi pi-user-edit"
                          style={{ fontSize: "3rem" }}
                        ></i>
                      </div>
                      <div className="col-md-10 col-sm-10 p-2">
                        <p className="m-0">
                          <p className="m-0 fs-5">My Contact</p>
                          <p className="m-0">
                            Keep your contact details up to date
                          </p>
                          <button
                            style={{
                              backgroundColor: "transparent",
                              color: "#70CDF3",
                            }}
                          >
                            {" "}
                            Change Contact
                          </button>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 ">
                    <div className="col-md-12 col-sm-12 d-flex  mb-2">
                      <div className="col-md col-sm d-flex justify-content-center align-items-center">
                        <RiShieldKeyholeLine style={{ fontSize: "3rem" }} />
                      </div>
                      <div className="col-md-10 col-sm-10 p-2">
                        <p className="m-0">
                          <p className="m-0 fs-5">My Access</p>
                          <p className="m-0">
                            Authorized features and functionalities
                          </p>
                          <button
                            style={{
                              backgroundColor: "transparent",
                              color: "#70CDF3",
                            }}
                          >
                            {" "}
                            View Access
                          </button>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 ">
                    <div className="col-md-12 col-sm-12 d-flex  mb-2">
                      <div className="col-md col-sm d-flex justify-content-center align-items-center">
                        <i
                          className="pi pi-bell"
                          style={{ fontSize: "3rem" }}
                        ></i>
                      </div>
                      <div className="col-md-10 col-sm-10 p-2">
                        <p className="m-0">
                          <p className="m-0 fs-5">Set Reminder</p>
                          <p className="m-0">
                            Authorized features and functionalities
                          </p>
                          <button
                            onClick={() => btnClick("rem")}
                            style={{
                              backgroundColor: "transparent",
                              color: "#70CDF3",
                            }}
                          >
                            {" "}
                            New Reminder
                          </button>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>

          </div>
        </div>
        <Dialog
          header="Security Information"
          visible={btnclicktxt === "pnp"}
          style={{ width: "40vw" }}
          onHide={() => btnClick("")}
        >
          <div className="col-md col-sm ">
            <div className="row">
              <div
                className="col-md-12 col-sm-6 p-3"
                style={{
                  height: "36vh",
                  overflow: "auto",
                  borderColor: "#BFBFBF",
                }}
              >
                <div className="row mb-4">
                  <div className="col-md-6 col-sm-6">
                    <label htmlFor="firstName" className="form-label">
                      First name
                    </label>
                    <input
                      type="text"
                      id="firstName"
                      className="form-control"
                      defaultValue={profileDetails?.firstName}
                      disabled
                    />
                  </div>
                  <div className="col-md-6 col-sm-6">
                    <label htmlFor="lastName" className="form-label">
                      Last name
                    </label>
                    <input
                      type="text"
                      id="lastName"
                      className="form-control"
                      defaultValue={profileDetails?.lastName}
                      disabled
                    />
                  </div>
                </div>
                <div className="row mb-4">
                  <div className="col-md-6 col-sm-6">
                    <label htmlFor="email" className="form-label">
                      Email
                    </label>
                    <input
                      type="email"
                      id="email"
                      className="form-control"
                      defaultValue={profileDetails?.primaryEmail}
                      disabled
                    />
                  </div>
                  <div className="col-md-6 col-sm-6">
                    <label htmlFor="secondaryEmail" className="form-label">
                      Secondary Email ID
                    </label>
                    <input
                      type="email"
                      defaultValue={profileDetails?.secondaryEmail}
                      id="secondaryEmail"
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="row mb-4">
                  <div className="col-md-6 col-sm-6">
                    <label htmlFor="" className="form-label">
                      Phone Number
                    </label>
                    <input
                      type="number"
                      defaultValue={profileDetails?.contactPhone}
                      className="form-control"
                      disabled
                    />
                  </div>
                  <div className="col-md-6 col-sm-6">
                    <label htmlFor="secondaryPhone" className="form-label">
                      Secondary phone Number
                    </label>
                    <input
                      defaultValue={profileDetails?.secondaryContactPhone}
                      type="number"
                      id="secondaryPhone"
                      className="form-control"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="text-end">
                <button className="btn btn-danger mx-2" onClick={clearFields}>
                  Cancel
                </button>
                <button className="btn btn-primary" onClick={SaveAppUser}>
                  Save
                </button>
              </div>
            </div>
          </div>
        </Dialog>
        <Dialog
          header="Change Password"
          visible={btnclicktxt === "pas"}
          style={{ width: "24vw" }}
          onHide={() => btnClick("")}
        >
          <form onSubmit={handleSubmit2(UpdateUserPassword)}>
            <div className="py-3 rounded mt-4">
              <div className="row mx-0 mb-3">
                <div className="form-group col">
                  <label className="ps-0 required">New Password</label>
                  <div className="input-group">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      className="form-control"
                      onInput={(e) => checkPassStrength(e)}
                      {...register2("password", { required: true })}
                    />
                    <button
                      type="button"
                      style={{ width: "2rem", border: "1px solid #d4d4d4" }}
                      onClick={togglePasswordVisibility}
                    >
                      <i
                        className={`pi ${
                          showPassword ? "pi-eye" : "pi-eye-slash"
                        }`}
                      ></i>
                    </button>
                  </div>
                  {errors2.password && (
                    <p className="text-danger">This field is required</p>
                  )}
                  {isShowPassStrength && (
                    <>
                      <p className="m-1">Password Hint </p>
                      {validationPass.map((a, i) => {
                        return (
                          <p
                            key={i}
                            className={`m-1 d-flex align-items-center ${
                              a.isValid
                                ? "custom-p2 text-success"
                                : "text-danger"
                            }`}
                          >
                            <i
                              className={`pi ${
                                a.isValid
                                  ? "pi pi-check text-success"
                                  : "pi-times-circle text-danger"
                              } `}
                              style={{ width: "5%" }}
                            ></i>
                            {a.title}
                          </p>
                        );
                      })}
                    </>
                  )}
                </div>
              </div>
              <div className="row mx-0 mb-3">
                <div className="form-group col">
                  <label className="ps-0 required">Confirm Password</label>
                  <div className="input-group">
                    <input
                      type={showPassword1 ? "text" : "password"}
                      name="confirmpass"
                      className="form-control"
                      {...register2("confirmpass", { required: true })}
                      onInput={(e) => checkBothPass(e)}
                    />
                    <button
                      type="button"
                      style={{ width: "2rem", border: "1px solid #d4d4d4" }}
                      onClick={togglePasswordVisibility1}
                    >
                      <i
                        className={`pi ${
                          showPassword1 ? "pi-eye" : "pi-eye-slash"
                        }`}
                      ></i>
                    </button>
                  </div>
                  {errors2.confirmpass && (
                    <p className="text-danger">This field is required</p>
                  )}
                  <p className="text-danger">{isPassValidMsg}</p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="text-end">
                <button
                  type="button"
                  className="btn btn-danger mx-2"
                  onClick={() => btnClick("")}
                >
                  Cancel
                </button>
                <button className="btn btn-primary" type="submit">
                  Save
                </button>
              </div>
            </div>
          </form>
        </Dialog>
        <Dialog
          header="Set Reminder"
          visible={btnclicktxt === "rem"}
          style={{ width: "60vw" }}
          onHide={clearBtn}
        >
          <div
            className="col-md col-sm  p-3"
            style={{ height: "70vh", overflow: "auto" }}
          >
            <div className="row">
              <div
                className="col-md-6 col-sm mb-3"
                style={{ overflowY: "scroll", minHeight: "55vh" }}
              >
                <div className="d-flex justify-content-between mb-2 text-center align-items-center">
                  <h5 className="m-0">Reminder List</h5>
                  {showButton && (
                    <button className="btn btn-primary" onClick={newBtn}>
                      New Reminder
                    </button>
                  )}
                </div>

                {getReminderDats.map((a, i) => (
                  <div key={i}>
                    <div className="col-md-12 col-sm-12 d-flex border border-1 rounded mb-2">
                      <div
                        className="col-md col-sm d-flex justify-content-center align-items-center"
                        style={{ backgroundColor: "rgb(231 243 219)" }}
                      >
                        <FaRegBell size="22" />
                      </div>
                      <div
                        className="col-md-10 col-sm-10 p-2"
                        style={{ backgroundColor: "#fdfdfd" }}
                        onClick={() => bindValues(a, "fd")}
                      >
                        <p className="m-0">
                          <strong>{a.title}</strong>
                          <span className="text-muted ms-2">
                            ({new Date(a.startDateTime).toLocaleDateString()} -{" "}
                            {new Date(a.endDateTime).toLocaleDateString()})
                          </span>
                        </p>
                        <p className="m-0">{a.detailDescription}</p>
                      </div>
                      <div className="col-md col-sm d-flex justify-content-end p-2">
                        <i
                          className="pi pi-pencil"
                          onClick={() => bindValues(a, "edit")}
                          style={{ color: "slateblue", cursor: "pointer" }}
                        ></i>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {isProcess && (
                <ProgressSpinner
                  style={{
                    width: "50px",
                    height: "50px",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                  }}
                  strokeWidth="2"
                  fill="var(--surface-ground)"
                  animationDuration=".5s"
                />
              )}
              <div className="col-md-6 col-sm mb-3 border-start">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="row">
                    <h5>Add New Reminder</h5>

                    <div className="col-md-6 col-sm">
                      <label
                        htmlFor="startDate"
                        className="form-label required"
                      >
                        Start Date
                      </label>
                      <Controller
                        name="startdate"
                        control={control}
                        rules={{ required: "This field is required" }}
                        render={({ field }) => (
                          <Calendar
                            {...field}
                            minDate={new Date()}
                            className="form-control p-0"
                            placeholder="Select start date"
                            disabled={isDisabled === "fd"}
                          />
                        )}
                      />
                      {errors.startdate && (
                        <p className="text-danger">This field is required</p>
                      )}
                    </div>
                    <div className="col-md-6 col-sm">
                      <label
                        htmlFor="startDate"
                        className="form-label required"
                      >
                        End Date
                      </label>
                      <Controller
                        name="enddate"
                        control={control}
                        rules={{
                          required: "This field is required",
                          // validate: () => validateDates(),
                        }}
                        render={({ field }) => (
                          <Calendar
                            {...field}
                            minDate={new Date()}
                            className="form-control p-0"
                            placeholder="Select start date"
                            disabled={isDisabled === "fd"}
                          />
                        )}
                      />
                      {errors.enddate && (
                        <p className="text-danger">
                          {frequency.name === "Weekly"
                            ? "Choose at least 14 days"
                            : frequency.name === "Monthly"
                            ? "Choose at least 60 days"
                            : errors.enddate.message ||
                              "An unknown error occurred."}
                        </p>
                      )}
                    </div>
                  </div>

                  <div className="row align-items-center mt-3">
                    <div className="col-md-3 col-sm-auto">
                      <label className="form-label me-2">Reminder Type:</label>
                    </div>
                    <div className="col-md col-sm-auto d-flex">
                      {categories.map((category) => (
                        <div
                          key={category.key}
                          className="flex align-items-center ms-2"
                        >
                          <RadioButton
                            className="me-1"
                            inputId={category.key}
                            name="category"
                            value={category}
                            disabled={isDisabled === "fd"}
                            onChange={(e) => {
                              setReminderType(e.value);
                              setFrequency(null);
                              setSelectDate(null);
                            }}
                            checked={reminderType.key === category.key}
                          />
                          <label htmlFor={category.key} className="">
                            {category.name}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="row mt-3">
                    {reminderType.key === "Repeat" && (
                      <div className="row mt-3">
                        <div className="col-md col-sm">
                          <label htmlFor="frequency" className="form-label">
                            Frequency
                          </label>
                          <Controller
                            name="frequency"
                            control={control}
                            rules={{
                              required:
                                reminderType.key === "Repeat" ? true : false,
                            }}
                            render={({ field }) => (
                              <Dropdown
                                {...field}
                                value={field.value || frequency}
                                onChange={(e) => {
                                  field.onChange(e.value);
                                  setFrequency(e.value);
                                }}
                                options={termName}
                                optionLabel="name"
                                placeholder="Select Frequency Type"
                                disabled={isDisabled === "fd"}
                                className="form-control"
                              />
                            )}
                          />
                          {errors.frequency && (
                            <p className="text-danger">
                              This field is required
                            </p>
                          )}
                        </div>
                        {frequency && (
                          <div className="col-md col-sm">
                            <label htmlFor="selectdate" className="form-label">
                              Select Date
                            </label>
                            <Controller
                              name="selectdate"
                              control={control}
                              rules={{
                                required:
                                  reminderType.key === "Repeat" ? true : false,
                              }}
                              render={({ field }) => (
                                <Calendar
                                  {...field}
                                  value={selectDate || field.value}
                                  // minDate={new Date()}
                                  className="form-control p-0"
                                  placeholder="Select date"
                                  disabled={isDisabled === "fd"}
                                  onChange={(e) => {
                                    field.onChange(e.value);
                                    setSelectDate(e.value);
                                  }}
                                />
                              )}
                            />
                            {errors.selectdate && (
                              <p className="text-danger">
                                This field is required
                              </p>
                            )}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  <div className="row mt-3">
                    <div className="col-md col-sm">
                      <label className="form-label required">
                        Reminder Title
                      </label>
                      <input
                        disabled={isDisabled === "fd"}
                        className="form-control"
                        {...register("remindertitle", {
                          required: true,
                        })}
                      />
                      {errors.remindertitle && (
                        <p className="text-danger">This field is required</p>
                      )}
                    </div>
                  </div>

                  <div className="row mt-3">
                    <div className="col-md col-sm">
                      <label
                        htmlFor="description"
                        className="form-label required"
                      >
                        Description
                      </label>
                      <InputTextarea
                        id="description"
                        className="form-control"
                        disabled={isDisabled === "fd"}
                        rows={5}
                        cols={30}
                        {...register("description", {
                          required: true,
                        })}
                      />
                      {errors.description && (
                        <p className="text-danger">This field is required</p>
                      )}
                    </div>
                  </div>
                </form>
                <div className="text-end mt-3">
                  <button
                    type="button"
                    className="btn btn-danger mx-2"
                    onClick={clearBtn}
                  >
                    Cancel
                  </button>
                  {isDisabled !== "fd" && (
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleSubmit(onSubmit)}
                    >
                      {isDisabled === "edit" ? "Update" : "Save"}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Dialog>
        <Dialog
          header="Add Your Signature"
          visible={btnclicktxt === "sig"}
          onHide={clearBtn}
          style={{ width: "450px" }}
          footer={
            <div>
              <button className="btn btn-danger" onClick={() => btnClick("")}>
                Cancel
              </button>
              <button
                className="btn btn-secondary"
                onClick={handleClearSignature}
              >
                Clear
              </button>
              <button className="btn btn-primary" onClick={saveSignature}>
                Save
              </button>
            </div>
          }
        >
          <div
            className="mt-4"
            style={{ border: "1px solid #000", height: "300px" }}
          >
            {documentURL && (
              <img
                src={documentURL}
                alt="User Signature"
                style={{ width: "100%", height: "100%", objectFit: "contain" }}
              />
            )}

            <SignatureCanvas
              ref={signaturePadRef}
              canvasProps={{
                width: 910,
                height: 300,
                className: "signature-canvas",
              }}
              penColor="black"
            />
          </div>
        </Dialog>
        <Dialog
        header="Update Profile Photo"
        visible={isCrop}
        onHide={() => setIsCrop(false)}
        style={{ width: "50vw", height: "80vh", overflow: "auto" }} 
        footer={
          <div>
            <button className="btn btn-danger" onClick={() => {setIsCrop(false); setImage(tempImage)}}>
              Cancel
            </button>
            
            <button className="btn btn-primary" onClick={handleSaveProfile}>
              Save
            </button>
          </div>
        }
      >
        <div className="cropper-container" style={{ position: "relative", height: "63vh", overflow: "auto" }}>
        {image && (
        <Cropper
          image={image}
          crop={crop}
          zoom={zoom}
          aspect={1}
          cropShape="round"
          cropSize={{ width: 500, height: 500 }}
          onCropChange={setCrop}
          onCropComplete={onCropComplete}
          onZoomChange={setZoom}
        />
      )}
        </div>
      </Dialog>
      </BlockUI>
    </>
  );
};

export default Profile;
